var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.45 48.125L27.9125 31.5875C26.6 32.6375 25.0906 33.4688 23.3844 34.0812C21.6781 34.6937 19.8625 35 17.9375 35C13.1687 35 9.13281 33.3484 5.82969 30.0453C2.52656 26.7422 0.875 22.7062 0.875 17.9375C0.875 13.1687 2.52656 9.13281 5.82969 5.82969C9.13281 2.52656 13.1687 0.875 17.9375 0.875C22.7062 0.875 26.7422 2.52656 30.0453 5.82969C33.3484 9.13281 35 13.1687 35 17.9375C35 19.8625 34.6937 21.6781 34.0812 23.3844C33.4688 25.0906 32.6375 26.6 31.5875 27.9125L48.125 44.45L44.45 48.125ZM17.9375 29.75C21.2188 29.75 24.0078 28.6016 26.3047 26.3047C28.6016 24.0078 29.75 21.2188 29.75 17.9375C29.75 14.6562 28.6016 11.8672 26.3047 9.57031C24.0078 7.27344 21.2188 6.125 17.9375 6.125C14.6562 6.125 11.8672 7.27344 9.57031 9.57031C7.27344 11.8672 6.125 14.6562 6.125 17.9375C6.125 21.2188 7.27344 24.0078 9.57031 26.3047C11.8672 28.6016 14.6562 29.75 17.9375 29.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.0f487ab43d89ef5e4f66e89384bec9c9.svg";
export { ForwardRef as ReactComponent };